import { createIcon } from '@chakra-ui/react';

export const Battery80PercentIcon = createIcon({
  displayName: 'Battery80PercentIcon',
  viewBox: '0 0 24 24',
  defaultProps: { fill: 'none', width: '24', height: '24' },
  path: (
    <path
      d="M19.9717 6.84521C20.8419 6.84534 21.5479 7.55109 21.5479 8.42139V9.80029C21.5728 9.79894 21.5978 9.79737 21.623 9.79736C22.3833 9.79736 23 10.4141 23 11.1743V12.8257C23 13.5859 22.3833 14.2026 21.623 14.2026C21.5978 14.2026 21.5728 14.2001 21.5479 14.1987V15.5796C21.5476 16.4497 20.8418 17.1556 19.9717 17.1558H2.90234C2.03213 17.1558 1.32643 16.4497 1.32617 15.5796V8.42139C1.32617 7.55101 2.03197 6.84521 2.90234 6.84521H19.9717ZM2.90234 8.34521C2.8604 8.34521 2.82617 8.37944 2.82617 8.42139V15.5796C2.82643 15.6213 2.86056 15.6558 2.90234 15.6558H19.9717C20.0134 15.6556 20.0476 15.6212 20.0479 15.5796V8.42139C20.0479 8.37952 20.0135 8.34534 19.9717 8.34521H2.90234ZM13.554 14.203H4.278V9.797H13.554V14.203Z"
      fill="#3EBD93"
      fillRule="evenodd"
    />
  ),
});
